export interface ICreateContact {
  email: string;
  message: string;
}

export class CreateContact {
  email: string;
  message: string;
}
